import { message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import {
  UPLOAD_FILES,
  DETELE_FILE,
  uploadType,
  UPLOAD_FILES_NO_SAVE,
} from '../../api/orderManage'
import {
  download,
  generateRegExp,
  GetLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { CustomerConfirm } from '../../components/ModalUser'
import { useContext, useState } from 'react'
import uploadContext from './uploadContext'
import { EMPTY_LIST } from '@/tools/state'
import { DELETE_CONTRACT_FILE } from '@/api/contractApi'

export interface fileFile {
  url: string
  baseUrl: string
  name?: string
  id?: string
}
export interface projectList {
  label: string
  value: string
}

export interface Props {
  dataSource?: fileFile[]
  onChange?: (e: fileFile[]) => void
  getOriginFile?: (e: RcFile) => void
  type?: uploadType
  title?: string
  code?: string
  disabled?: boolean
  canNotUploadEvent?: () => void // 禁止上传文件事件
  accept?: string // 接收文件类型
  directlyDelete?: boolean // 不通过接口直接删除
  maxCount?: number
  notSaveInBase?: boolean // 调用不存表上传接口
  hiddenDownload?: boolean // 隐藏下载按钮
  NoUploadButton?: boolean // 展示上传按钮
  disabledDel?: boolean // 禁用删除按钮
  customerConfirmTitle?: string // 删除按钮二次确认弹窗标题
  customerConfirmContent?: string // 删除按钮二次确认弹窗内容
  uploadBtnStyle?: any
}
export default function useHook(props: Props) {
  const {
    code,
    dataSource = EMPTY_LIST,
    type,
    directlyDelete,
    maxCount,
    notSaveInBase,
    onChange,
    accept,
    getOriginFile,
    customerConfirmTitle,
    customerConfirmContent,
  } = props
  const [previewFileUrl, setPreviewFileUrlUrl] = useState('')
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false)
  const UPLOAD_PORT = notSaveInBase ? UPLOAD_FILES_NO_SAVE : UPLOAD_FILES
  const BASEURL = GetLocalStorage('BASEURL')

  const { setModalLoading } = useContext(uploadContext)

  async function uploadfile(file: RcFile) {
    setModalLoading(true)
    getOriginFile?.(file)
    const res = await UPLOAD_PORT({ type: type, code: code }, file)
    if (isResponseCodeSuccess(res.code)) {
      onChange?.([...dataSource, ...res.data])
    }
  }

  // 删除文件
  async function onClickDel(fileItem: fileFile) {
    if (directlyDelete) {
      const arr = dataSource.filter((item) => item.url !== fileItem.url)
      onChange?.(arr)
      getOriginFile?.(undefined as any)
      return
    }
    CustomerConfirm({
      title: customerConfirmTitle || '提示',
      content: customerConfirmContent || '此操作将永久删除附件，是否继续?',
      onOk: async () => {
        const promise =
          type === 'contract'
            ? DELETE_CONTRACT_FILE({ id: fileItem.id || '' })
            : DETELE_FILE({ id: fileItem.id || '' })
        const res = await promise
        if (isResponseCodeSuccess(res.code)) {
          const arr = dataSource.filter((item) => item.url !== fileItem.url)
          onChange?.(arr)
          getOriginFile?.(undefined as any)
        } else {
          message.warning('删除失败')
        }
      },
    })
  }
  // 下载文件
  function onClickDown(fileItem: fileFile) {
    // 获取下载路径
    const url = `${BASEURL}${fileItem.url}`
    download(url)
  }

  // 上传之前处理文件
  function beforeUpload(file: RcFile) {
    const reg = accept
      ? generateRegExp(accept)
      : new RegExp(
          /^.*(\.doc|\.docx|\.pdf|\.xlsx|\.xls|\.png|\.jpg|\.svg|\.jpeg)$/,
        )
    const index = file.name.search(reg)
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      return false
    } else if (
      !dataSource.every(
        (item: any) => file.name.indexOf(item.name ? item.name : '') === -1,
      )
    ) {
      message.error('上传失败：图片重复')
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      return false
    }
    if (maxCount && dataSource.length >= maxCount) {
      message.error(`不能超过${maxCount}个附件`)
      return false
    }
    uploadfile(file)
    return false
  }
  const cancelPreviewModal = () => {
    setIsPreviewModalVisible(false)
  }
  const showPreviewModal = (item: fileFile) => {
    setPreviewFileUrlUrl(
      item.baseUrl ? item.baseUrl + item.url : BASEURL + item.url,
    )
    setIsPreviewModalVisible(true)
  }
  return {
    isPreviewModalVisible,
    previewFileUrl,
    dataSource,
    beforeUpload,
    onClickDel,
    onClickDown,
    uploadfile,
    cancelPreviewModal,
    showPreviewModal,
  }
}
import { message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import {
  UPLOAD_FILES,
  DETELE_FILE,
  uploadType,
  UPLOAD_FILES_NO_SAVE,
} from '../../api/orderManage'
import {
  download,
  generateRegExp,
  GetLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { CustomerConfirm } from '../../components/ModalUser'
import { useContext, useState } from 'react'
import uploadContext from './uploadContext'
import { EMPTY_LIST } from '@/tools/state'
import { DELETE_CONTRACT_FILE } from '@/api/contractApi'

export interface fileFile {
  url: string
  baseUrl: string
  name?: string
  id?: string
}
export interface projectList {
  label: string
  value: string
}

export interface Props {
  dataSource?: fileFile[]
  onChange?: (e: fileFile[]) => void
  getOriginFile?: (e: RcFile) => void
  type?: uploadType
  title?: string
  code?: string
  disabled?: boolean
  canNotUploadEvent?: () => void // 禁止上传文件事件
  accept?: string // 接收文件类型
  directlyDelete?: boolean // 不通过接口直接删除
  maxCount?: number
  notSaveInBase?: boolean // 调用不存表上传接口
  hiddenDownload?: boolean // 隐藏下载按钮
  NoUploadButton?: boolean // 展示上传按钮
  disabledDel?: boolean // 禁用删除按钮
  customerConfirmTitle?: string // 删除按钮二次确认弹窗标题
  customerConfirmContent?: string // 删除按钮二次确认弹窗内容
  uploadBtnStyle?: any
}
export default function useHook(props: Props) {
  const {
    code,
    dataSource = EMPTY_LIST,
    type,
    directlyDelete,
    maxCount,
    notSaveInBase,
    onChange,
    accept,
    getOriginFile,
    customerConfirmTitle,
    customerConfirmContent,
  } = props
  const [previewFileUrl, setPreviewFileUrlUrl] = useState('')
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false)
  const UPLOAD_PORT = notSaveInBase ? UPLOAD_FILES_NO_SAVE : UPLOAD_FILES
  const BASEURL = GetLocalStorage('BASEURL')

  const { setModalLoading } = useContext(uploadContext)

  async function uploadfile(file: RcFile) {
    setModalLoading(true)
    getOriginFile?.(file)
    const res = await UPLOAD_PORT({ type: type, code: code }, file)
    if (isResponseCodeSuccess(res.code)) {
      onChange?.([...dataSource, ...res.data])
    }
  }

  // 删除文件
  async function onClickDel(fileItem: fileFile) {
    if (directlyDelete) {
      const arr = dataSource.filter((item) => item.url !== fileItem.url)
      onChange?.(arr)
      getOriginFile?.(undefined as any)
      return
    }
    CustomerConfirm({
      title: customerConfirmTitle || '提示',
      content: customerConfirmContent || '此操作将永久删除附件，是否继续?',
      onOk: async () => {
        const promise =
          type === 'contract'
            ? DELETE_CONTRACT_FILE({ id: fileItem.id || '' })
            : DETELE_FILE({ id: fileItem.id || '' })
        const res = await promise
        if (isResponseCodeSuccess(res.code)) {
          const arr = dataSource.filter((item) => item.url !== fileItem.url)
          onChange?.(arr)
          getOriginFile?.(undefined as any)
        } else {
          message.warning('删除失败')
        }
      },
    })
  }
  // 下载文件
  function onClickDown(fileItem: fileFile) {
    // 获取下载路径
    const url = `${BASEURL}${fileItem.url}`
    download(url)
  }

  // 上传之前处理文件
  function beforeUpload(file: RcFile) {
    const reg = accept
      ? generateRegExp(accept)
      : new RegExp(
          /^.*(\.doc|\.docx|\.pdf|\.xlsx|\.xls|\.png|\.jpg|\.svg|\.jpeg)$/,
        )
    const index = file.name.search(reg)
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      return false
    } else if (
      !dataSource.every(
        (item: any) => file.name.indexOf(item.name ? item.name : '') === -1,
      )
    ) {
      message.error('上传失败：图片重复')
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      return false
    }
    if (maxCount && dataSource.length >= maxCount) {
      message.error(`不能超过${maxCount}个附件`)
      return false
    }
    uploadfile(file)
    return false
  }
  const cancelPreviewModal = () => {
    setIsPreviewModalVisible(false)
  }
  const showPreviewModal = (item: fileFile) => {
    setPreviewFileUrlUrl(
      item.baseUrl ? item.baseUrl + item.url : BASEURL + item.url,
    )
    setIsPreviewModalVisible(true)
  }
  return {
    isPreviewModalVisible,
    previewFileUrl,
    dataSource,
    beforeUpload,
    onClickDel,
    onClickDown,
    uploadfile,
    cancelPreviewModal,
    showPreviewModal,
  }
}
